import React, { FC, createContext, useContext } from 'react';
import { SemTrackingInfo } from './index';

type SemItineraryContextType = {
  semItinerary: object;
  semItineraryPosition: number;
  semSearchId: number;
  semTrackingInfo: SemTrackingInfo;
};

const SemItineraryContext = createContext<SemItineraryContextType>({
  semItinerary: {},
  semItineraryPosition: 0,
  semSearchId: 0,
  semTrackingInfo: { returningUserDeviceId: '' },
});

export const useSemItinerary = (): any =>
  useContext(SemItineraryContext).semItinerary;

export const useSemItineraryPosition = (): number =>
  useContext(SemItineraryContext).semItineraryPosition;

export const useSemSearchId = (): number =>
  useContext(SemItineraryContext).semSearchId;

export const useSemTrackingInfo = (): SemTrackingInfo =>
  useContext(SemItineraryContext).semTrackingInfo;

const SemItineraryProvider: FC<SemItineraryContextType> = ({
  children,
  semItinerary,
  semItineraryPosition,
  semSearchId,
  semTrackingInfo,
}) => {
  return (
    <SemItineraryContext.Provider
      value={{
        semItinerary,
        semItineraryPosition,
        semSearchId,
        semTrackingInfo,
      }}
    >
      {children}
    </SemItineraryContext.Provider>
  );
};

export default SemItineraryProvider;
